<template>
    <div class="msg">
        <div class="loading">
            <img :src="src" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name:'Loading',
    data(){
        return{
            src:'./static/img/loading.gif'
        }
    },
    methods:{
        
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .loading{
        width:300px;
        height:300px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-150px;
        margin-left:-150px;
    }
    .loading img{
        width:100%;
        height:100%;
    }
    /* .loading{
        width:200px;
        height:200px;
        border:10px solid #1b4180;
        border-left:10px solid transparent;
        border-radius:50%;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-100px;
        margin-left:-100px;
        animation:turn 1s linear infinite;
    }
    @keyframes turn{
        0%{
            transform:rotate(0deg);
        }
        25%{
            transform:rotate(90deg);
        }
        50%{
            transform:rotate(180deg);
        }
        75%{
            transform:rotate(270deg);
        }
        100%{
            transform:rotate(360deg);
        }
    } */
</style>





// WEBPACK FOOTER //
// src/components/Loading.vue